import { NotificationDataSource } from "./NotificationDataSource";
import { PushNotificationResponse } from "@/data/dtos/responses";
import { ApiService } from "@/domain/clients";
import { Endpoints } from "@/infra/api";

export class NotificationRemoteDataSource implements NotificationDataSource {
  constructor(private readonly api: ApiService) {}

  async getNotifications(): Promise<PushNotificationResponse[]> {
    const { data } = await this.api.get<PushNotificationResponse[]>(
      Endpoints.notifications,
    );

    if (!data) return [];

    return data;
  }
}
